import apiClient from './authService';

export const organizationService = {
  getMe: () =>
    apiClient.get('/api/organizations/me').then(r => r.data),

  getUsage: () =>
    apiClient.get('/api/organizations/usage').then(r => r.data),

  updateMe: (body) =>
    apiClient.put('/api/organizations/me', body).then(r => r.data),
};
